import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import store from "../store/index";

import Home from "../views/home/Home.vue";
import Auth from "../views/auth/Auth.vue";
import Manuais from "../views/manuais/Manuais.vue";
import Convenios from "../views/convenios/Convenios.vue";
import Dependentes from "../views/dependentes/Dependentes.vue";
import Documentos from "../views/documentos/Documentos.vue";
import Holerites from "../views/holerites/Holerites.vue";
import DemonstrativoFerias from "../views/demonstrativoferias/DemonstrativoFerias.vue";
import CandidaturaInterna from "../views/candidatura-interna/CandidaturaInterna.vue";
import Notificacoes from "../views/notificacoes/Notificacoes.vue";
import MinhaConta from "../views/minha-conta/MinhaConta.vue";
import LimitesConsumo from "../views/limites-consumo/LimitesConsumo.vue";
import Atestados from "../views/atestados/Atestados.vue";
import EnviarAtestado from "../views/atestados/enviar-atestado/EnviarAtestado.vue";
import IncluirDependente from "../views/dependentes/incluir-dependente/IncluirDependente.vue";
import Emprestimos from "../views/emprestimos/Emprestimos.vue";
import Treinamentos from "../views/treinamentos/Treinamentos.vue";
import VisualizarTreinamentos from "../views/treinamentos/VisualizarTreinamentos.vue";
import AtualizacaoCadastral from "../views/atualizacao-cadastral/AtualizacaoCadastral";
import PlanoSaude from "../views/plano-saude/PlanoSaude";
import SimularPlanoSaude from "../views/plano-saude/components/SimularPlanoSaude";
import IndicarPCD from "../views/indicar-pcd/IndicarPcd.vue";
import EnviarDocumento from "../views/documentos/components/EnviarDocumento.vue";
import EditarDocumento from "../views/documentos/components/EditarDocumento.vue";
import AtualizacaoContato from "../views/atualizacao-cadastral/AtualizacaoContato.vue";
import Erro404View from "../views/errors/Erro404View.vue";
import AtualizacaoEndereco from "../views/atualizacao-cadastral/AtualizacaoEndereco.vue";
import AtualizacaoDadosPessoais from "../views/atualizacao-cadastral/AtualizacaoDadosPessoais.vue";
import AtualizacaoEscolaridade from "../views/atualizacao-cadastral/AtualizacaoEscolaridade.vue";
import PlanosBeneficios from "../views/planos-beneficios/PlanosBeneficios.vue";
import ConfigComprasPrazo from "../views/config-compras-prazo/ConfigComprasPrazo.vue";
import CuponsPage from '../views/cupons/CuponsPage.vue'
import Ganhadores from '../views/cupons/Ganhadores.vue'
// import EnviarCodigoSeguranca from "../views/config-compras-prazo/components/EnviarCodigoSeguranca.vue";
// import ValidarCodigoSeguranca from "../views/config-compras-prazo/components/ValidarCodigoSeguranca.vue";
//import VisualizarPlanosBeneficios from "../views/planos-beneficios/VisualizarPlanosBeneficios.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "Coasul - 404",
    component: Erro404View,
    meta: {
      requiresLogin: true,
      sync: false,
      online: false,
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth,
    meta: { requiresLogin: false, verifyPermission: false },
  },
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/manuais",
    name: "manuais",
    component: Manuais,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/convenios",
    name: "convenios",
    component: Convenios,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/dependentes",
    name: "dependentes",
    component: Dependentes,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/documentos",
    name: "documentos",
    component: Documentos,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/holerites",
    name: "holerites",
    component: Holerites,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/demonstrativo-ferias",
    name: "demonstrativo-ferias",
    component: DemonstrativoFerias,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/candidatura-interna",
    name: "candidatura-interna",
    component: CandidaturaInterna,
    meta: { requiresLogin: true, verifyPermission: true },
  },
  {
    path: "/notificacoes",
    name: "notificacoes",
    component: Notificacoes,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/minha-conta",
    name: "minha-conta",
    component: MinhaConta,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/limites-consumo",
    name: "limites-consumo",
    component: LimitesConsumo,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atestados",
    name: "atestados",
    component: Atestados,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/enviar-atestado",
    name: "enviar-atestado",
    component: EnviarAtestado,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/editar-atestado/:id",
    name: "editar-atestado",
    component: EnviarAtestado,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/incluir-dependente",
    name: "incluir-dependente",
    component: IncluirDependente,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/editar-dependente/:id",
    name: "editar-dependente",
    component: IncluirDependente,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/emprestimos",
    name: "emprestimos",
    component: Emprestimos,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/treinamentos",
    name: "treinamentos",
    component: Treinamentos,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/treinamentos/:tipo",
    name: "visualizar-treinamentos",
    component: VisualizarTreinamentos,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atualizacao-cadastral",
    name: "atualizacao-cadastral",
    component: AtualizacaoCadastral,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atualizacao-cadastral/contato",
    name: "Atualização Contato",
    component: AtualizacaoContato,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atualizacao-cadastral/endereco",
    name: "Atualização Endereço",
    component: AtualizacaoEndereco,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atualizacao-cadastral/dados-pessoais",
    name: "Atualização Dados Pessoais",
    component: AtualizacaoDadosPessoais,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/atualizacao-cadastral/escolaridade",
    name: "Atualização Escolaridade",
    component: AtualizacaoEscolaridade,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/plano-saude",
    name: "plano-saude",
    component: PlanoSaude,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/simular-plano-saude",
    name: "simular-plano-saude",
    component: SimularPlanoSaude,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/indicar-pcd",
    name: "indicar-pcd",
    component: IndicarPCD,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/enviar-documento",
    name: "enviar-documento",
    component: EnviarDocumento,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/editar-documento/:id",
    name: "editar-documento",
    component: EditarDocumento,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/cupons",
    name: "cupons",
    component: CuponsPage,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/ganhadores-dia-trabalhador",
    name: "ganhadores-dia-trabalhador",
    component: Ganhadores,
    meta: { requiresLogin: true, verifyPermission: false },
  },
  {
    path: "/config-compras-prazo",
    name: "config-compras-prazo",
    component: ConfigComprasPrazo,
    meta: { requiresLogin: true, verifyPermission: false },
    /*children: [
      {
        path: "enviar-codigo-seguranca", // Isso define a rota padrão como '/'
        component: EnviarCodigoSeguranca,
        meta: { requiresLogin: true, verifyPermission: false },
      },
      {
        path: "/validar-codigo-seguranca", // Isso define a rota padrão como '/'
        component: ValidarCodigoSeguranca,
      }, 
      {
        path: "/validar-codigo-seguranca", // Isso define a rota padrão como '/'
        component: ValidarCodigoSeguranca,
      },   
         
    ],*/
  },
  {
    path: "/planos-beneficios",
    name: "planos-beneficios",
    component: PlanosBeneficios,
    meta: { requiresLogin: true, verifyPermission: false },
  }
  /*{
    path: "/planos-beneficios/:plano",
    name: "planos-beneficios",
    component: VisualizarPlanosBeneficios,
    meta: { requiresLogin: true, verifyPermission: false },
  },*/
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  store.state.usuario.loadingApp = true;
  if (to.meta.requiresLogin) {
    await store.dispatch("usuario/validarToken");
  }

  if (store.state.usuario.usuarioLogado == null && to.meta.requiresLogin) {
    next("/auth");
  } else if (to.meta.verifyPermission) {
    if (!(await getPermissaoRota(to.name))) {
      next("/");
    }
  }

  if (store.state.usuario.usuarioLogado) {
    await store.dispatch("usuario/getPendencias");
  }

  next();
  store.state.usuario.loadingApp = false;
});

async function getPermissaoRota(rota) {
  try {
    var res = await axios.get(
      `/colaborador/modulos?funcao=PERMISSAO-ROTA&rota=${rota}`
    );
    return res.data.data.permissao;
  } catch (error) {
    return false;
  }
}

export default router;
